import { makeChartComp } from '../../util/makeChartComp';
var TreemapChart = makeChartComp('Treemap');
export default TreemapChart;
